/**
 * Returns the report changes that have not been viewed yet (`viewed_at` unset).
 * Shared by the Monitored Reports list count and the changes panel so both use
 * the same definition of "unviewed".
 */
export function getUnviewedChanges<T extends { viewed_at?: Date | null }>(
  changes: T[]
): T[] {
  return changes.filter((change) => !change.viewed_at);
}
